// Build a downloadable .ics calendar file from a list of game objects.
function pad(n) { return String(n).padStart(2, "0"); }

function toIcsDate(dateStr, time = "19:00") {
  // dateStr "YYYY-MM-DD" -> "YYYYMMDDTHHMMSS"
  const [y, m, d] = dateStr.split("-");
  const [hh, mm] = time.split(":");
  return `${y}${m}${d}T${pad(hh)}${pad(mm)}00`;
}

function escapeIcs(text) {
  return String(text || "").replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/,/g, "\\,").replace(/;/g, "\\;");
}

export function buildIcs(games, season = "NPHS Canucks") {
  const now = new Date();
  const stamp = `${now.getUTCFullYear()}${pad(now.getUTCMonth() + 1)}${pad(now.getUTCDate())}T${pad(now.getUTCHours())}${pad(now.getUTCMinutes())}${pad(now.getUTCSeconds())}Z`;

  const events = games
    .filter((g) => g.date)
    .map((g) => {
      const start = toIcsDate(g.date, "19:00");
      const end = toIcsDate(g.date, "21:00");
      const title = `${season}: ${g.home_away === "home" ? "vs" : "@"} ${g.opponent}${g.playoff ? " (Playoff)" : ""}`;
      const location = g.location || (g.home_away === "home" ? "NPHS Gymnasium" : "Away");
      const desc = g.notes || "";
      return [
        "BEGIN:VEVENT",
        `UID:nphs-${g.id}@nphs-canucks`,
        `DTSTAMP:${stamp}`,
        `DTSTART:${start}`,
        `DTEND:${end}`,
        `SUMMARY:${escapeIcs(title)}`,
        `LOCATION:${escapeIcs(location)}`,
        `DESCRIPTION:${escapeIcs(desc)}`,
        "END:VEVENT",
      ].join("\r\n");
    })
    .join("\r\n");

  return [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//NPHS Canucks//Stats Platform//EN",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    `X-WR-CALNAME:${season}`,
    events,
    "END:VCALENDAR",
  ].join("\r\n");
}

export function downloadIcs(games, filename = "nphs-canucks.ics") {
  const ics = buildIcs(games);
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
